module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a8-3-1a627dfd872846b930ce36d617456ca3.jpg";